import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-maintenance-logout-dialog',
  templateUrl: './maintenance-logout-dialog.component.html',
  styleUrls: ['./maintenance-logout-dialog.component.css']
})
export class MaintenanceLogoutDialogComponent implements OnInit, OnDestroy, OnChanges {
  @Input() visible: boolean = false;
  @Input() secondsRemaining: number = 0;
  @Output() onConfirm = new EventEmitter<void>();

  displayMinutes: number = 0;
  displaySeconds: number = 0;
  private timerSubscription?: Subscription;
  private remainingTimeMs: number = 0;

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['secondsRemaining'] && changes['secondsRemaining'].currentValue > 0) {
      this.timerSubscription?.unsubscribe();
      this.startCountdown();
    }
  }

  ngOnDestroy(): void {
    this.timerSubscription?.unsubscribe();
  }

  private startCountdown(): void {
    this.remainingTimeMs = this.secondsRemaining * 1000;
    this.updateDisplay();
    
    this.timerSubscription = interval(1000).subscribe(() => {
      this.remainingTimeMs -= 1000;
      if (this.remainingTimeMs <= 0) {
        this.remainingTimeMs = 0;
        this.timerSubscription?.unsubscribe();
      }
      this.updateDisplay();
    });
  }

  private updateDisplay(): void {
    const totalSeconds = Math.floor(this.remainingTimeMs / 1000);
    this.displayMinutes = Math.floor(totalSeconds / 60);
    this.displaySeconds = totalSeconds % 60;
  }

  onOkClick(): void {
    this.onConfirm.emit();
    this.visible = false;
  }
}
